"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSuggestedActionStyle;

function createSuggestedActionStyle(_ref) {
  var paddingRegular = _ref.paddingRegular,
      paddingWide = _ref.paddingWide,
      primaryFont = _ref.primaryFont,
      suggestedActionBackground = _ref.suggestedActionBackground,
      suggestedActionBorder = _ref.suggestedActionBorder,
      suggestedActionBorderRadius = _ref.suggestedActionBorderRadius,
      suggestedActionImageHeight = _ref.suggestedActionImageHeight,
      suggestedActionTextColor = _ref.suggestedActionTextColor,
      suggestedActionDisabledBackground = _ref.suggestedActionDisabledBackground,
      suggestedActionDisabledBorder = _ref.suggestedActionDisabledBorder,
      suggestedActionDisabledTextColor = _ref.suggestedActionDisabledTextColor,
      suggestedActionHeight = _ref.suggestedActionHeight;
  return {
    paddingBottom: paddingRegular,
    paddingLeft: paddingRegular / 2,
    paddingRight: paddingRegular / 2,
    paddingTop: paddingRegular,
    '& > button': {
      alignItems: 'center',
      borderRadius: suggestedActionBorderRadius,
      display: 'flex',
      fontFamily: primaryFont,
      fontSize: 'inherit',
      height: suggestedActionHeight,
      paddingLeft: paddingWide,
      paddingRight: paddingWide,
      '&:disabled': {
        background: suggestedActionDisabledBackground,
        border: suggestedActionDisabledBorder,
        color: suggestedActionDisabledTextColor
      },
      '&:not(:disabled)': {
        background: suggestedActionBackground,
        border: suggestedActionBorder,
        color: suggestedActionTextColor
      },
      '& > img': {
        height: suggestedActionImageHeight,
        paddingRight: paddingRegular
      }
    }
  };
}